import React, { useEffect, useRef, useState } from "react";
import {
  TrashIcon,
  CurrencyDollarIcon,
  PhotoIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/solid";
import { getCurrencyAndLanguageSymbol } from "../../../../constent/currencyUtils";

const DetailsRow = ({
  details,
  onDelete,
  onEdit,
  areas,
  onPrice,
  onGallery,
  getLinkButton,
}) => {
  const roundToTwo = (num) => parseFloat(Number(num).toFixed(2));
  const matchedArea = Array.isArray(areas)
    ? areas.find((area) => area._id === details.area)
    : null;
  const currencySymbol = getCurrencyAndLanguageSymbol();
  const [showValue, setShowValue] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowValue(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const toggleValue = () => {
    setShowValue((prev) => !prev);
  };
  const values = [
    details.number,
    details.Box,
    details.image,
    details.nameProduct,
    details.info,
    details.size,
    roundToTwo(Number(details.price)),
    roundToTwo(Number(details.DShippingFees)),
    getLinkButton(details.link),
    details.Count,
    details.status,
    matchedArea
      ? matchedArea.name?.[localStorage.getItem("language") || "en"]
      : "wating...",
    roundToTwo(Number(details.price) * Number(details.Count) + Number(details.DShippingFees)),
    details.history ? new Date(details.history).toISOString().slice(5, 10) : "",
  ];
  return (
    <tr className="text-sm text-center text-gray-800 bg-white">
      {values.map((value, index) => (
        <td key={index} className="px-2 py-2">
          {index === 2 ? (
            <span className="flex justify-center text-black cursor-pointer">
              <img src={value} alt="Product" className="w-10" />
            </span>
          ) : index === 4 ? (
            <>
              <div className="relative inline-block ">
                <span
                  onClick={toggleValue}
                  ref={buttonRef}
                  className="flex px-2 py-2 text-xs text-black cursor-pointer bg-custom-yellow"
                >
                  Show Info
                </span>

                {showValue && (
                  <div
                    className="absolute z-50 w-[500px] px-2 py-1 mt-2 text-sm bg-white border rounded shadow "
                    ref={dropdownRef}
                  >
                    {value}
                  </div>
                )}
              </div>
            </>
          ) : index === 6 || index === 7 || index === 12 ? (
            <>
              <span className="text-black">
                {value}{" "}
                <span className="text-[9px] text-black"> {currencySymbol}</span>
              </span>
            </>
          ) : index === 10 ? (
            value === "pending" ? (
              <span
                title={value}
                className="px-2 text-black bg-red-300 rounded-lg"
              >
                {value}
              </span>
            ) : (
              <span
                title={value}
                className="px-2 text-black bg-blue-300 rounded-lg"
              >
                {value}
              </span>
            )
          ) : (
            value
          )}
        </td>
      ))}
      <td className="px-2 py-2">
        <div className="flex justify-around space-x-2">
          {details.status === "priced" ? (
            <button onClick={onEdit}>
              <PencilSquareIcon className="w-5 h-5 text-black" />
            </button>
          ) : (
            <button onClick={onPrice} title="Add Price">
              <CurrencyDollarIcon className="w-5 h-5 text-green-600" />
            </button>
          )}
          <button onClick={onGallery}>
            <PhotoIcon className="w-5 h-5 text-black" />
          </button>

          <button onClick={onDelete}>
            <TrashIcon className="w-5 h-5 text-red-600" />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default DetailsRow;
